<template>     
 <v-dialog v-model="dialog2" transition> 
  <v-card  class="vcard" 
   >  
  <v-flex>
   <v-chip
      class="ma-2"      
      outlined
    >
      <v-icon left>
        mdi-pencil
      </v-icon>
     標題
    </v-chip>  
          <span class="newstitle">{{item.carepaper_title}}</span>
          </v-flex>
          <v-flex>
 <v-chip
      class="ma-2"
      color="accent-4"
      outlined
    >
  <v-icon left>
       mdi-file-document-multiple-outline
      </v-icon>
      內容
      </v-chip> 
        </v-flex>
<v-flex mb-5>
<div class="fck" v-html="item.carepaper_content">
</div>
</v-flex>
      <v-flex xs1 md1 lg1 v-if="!!item.carepaper_file">
           <v-chip
      class="ma-2"
      color="accent-4"
      outlined
    >
  <v-icon left>
        mdi-files
      </v-icon>
            附檔
            </v-chip>
          </v-flex>
          <v-flex xs11 md11 lg11>
            <span>{{item.carepaper_file}}</span>
          </v-flex>
            <v-flex xs1 md1 lg1 v-if="!!item.carepaper_url">
  <v-chip
      class="ma-2"
      color="accent-4"
      outlined
    >
  <v-icon left>
        mdi-files
      </v-icon>
            相關連結
            </v-chip>
  </v-flex>
           <v-flex xs11 md11 lg11>
            <div @click="navLink(item.carepaper_url)">{{item.carepaper_url}}</div>
          </v-flex> 
 <!-- <v-overlay absolute :value="loading">
        <v-progress-circular size="64" indeterminate />
      </v-overlay>   -->
       <v-card-actions>
       <v-col class="text-center">
     <v-btn          
       @click="dialog2=false"  
       class="btn_close"     
    >
      <v-icon large left>
        mdi-close-circle-outline
      </v-icon>
      關閉
    </v-btn>
    </v-col>
     </v-card-actions>     
   </v-card>
  </v-dialog>    
</template>

<script>
  export default {
  props: { value: Boolean, item: Object },

  data: () => ({
  dense:false,
  loading: false
   
    }),
computed: {   
     dialog2: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  };
</script>
<style >

</style>
